import { createContext, useCallback, useContext, useState } from "react";
import { BookingDialog } from "@/components/BookingDialog";

const Ctx = createContext(null);

export function BookingDialogProvider({ children }) {
  const [state, setState] = useState({ open: false, booking: null, defaults: {} });
  const [version, setVersion] = useState(0);

  const openNew = useCallback((defaults = {}) => setState({ open: true, booking: null, defaults }), []);
  const openEdit = useCallback((booking) => setState({ open: true, booking, defaults: {} }), []);
  const refresh = useCallback(() => setVersion((v) => v + 1), []);

  return (
    <Ctx.Provider value={{ openNew, openEdit, version, refresh }}>
      {children}
      <BookingDialog
        open={state.open}
        booking={state.booking}
        defaults={state.defaults}
        onOpenChange={(open) => setState((s) => ({ ...s, open }))}
        onSaved={refresh}
      />
    </Ctx.Provider>
  );
}

export const useBookingDialog = () => useContext(Ctx);
